// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".toast{visibility:hidden;z-index:2300}.toast__content{transition:opacity .5s,visibility 0s linear .5s;opacity:0;height:48px;box-shadow:0 2px 4px 0 rgba(0,0,0,.5)}.toast__content--active{visibility:visible;opacity:1;transition-delay:0s}", ""]);
// Exports
module.exports = exports;
